import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  NgZone
} from "@angular/core";
import {
  Type,
  Status,
  NotifyModel
} from "@root/router/component/message/message.service";
import { Router } from "@angular/router";
import { HouseStatusService } from "@root/router/house/house-status/house-status.service";
import _ from "lodash";
import { AccountService } from "@root/router/channel/account/account.service";
import { ERROR_CODE } from "@root/config";
// interface MessageData {
//   type?: number;
//   status?: 1 | 2 | 3 | number; // 1 进行中  2 成功  3 失败
//   payload?: any;
// }

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "host-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.scss"]
})
export class MessageComponent implements OnInit {
  @Input() position = "right";
  @Input() message: NotifyModel;
  @Output() removeMessage = new EventEmitter();
  @Output() replaceMessage = new EventEmitter();
  @Output() hideMessage = new EventEmitter();
  constructor(
    private statusService: HouseStatusService,
    private accountService: AccountService,
    private router: Router,
    private zone: NgZone
  ) {}

  ngOnInit() {}
  bindHouse(messageId: number) {
    // this.removeMessage.emit(messageId);
    /**
     * tip: 跳转延迟为angular的一个bug，参见github问题描述
     * 此为暂时性解决方案
     */
    this.zone.run(() => {
      this.router.navigate(["/app/properties/relation"]);
      this.removeMessage.emit(messageId);
    });
  }
  nowOperate(messageId: number) {
    this.zone.run(() => {
      this.router.navigate(["/app/properties/relation"]);
      this.removeMessage.emit(messageId);
    });
  }

  /** 重试失败的同步房源 */
  retrySyncHouse(tasks: Array<any>) {
    const taskIds = tasks.map(t => t.id);
    this.accountService
      .retryFailedTasks({
        task_ids: JSON.stringify(taskIds)
      })
      .subscribe(res => {
        this.replaceMessage.emit({
          id: Type.SYNC,
          data: new NotifyModel({
            type: Type.SYNC,
            status: Status.DOING,
            payload: {
              title: "线上房源读取中0%..."
            }
          }),
          option: { position: "center" }
        });
      });
  }

  syncHouseOrigin(e) {
    this.accountService.syncerAllHouse().subscribe(res => {
      if (res.error_code !== ERROR_CODE.SUCCESS) {
        return;
      }
    });
  }
  /** 重试失败的同步价格 */
  // retrySyncPrice(type, taskIds: Array<number>, tasks) {
  //   console.log(tasks);
  //   console.log(taskIds);
  //   this.notifyService
  //     .retryUpdatePrice({
  //       task_id: JSON.stringify(taskIds)
  //     })
  //     .subscribe(res => {
  //       _.forEach(tasks, task => (task.status = 1));
  //       /** 将tasks存入本地，方便更新的时候取出来显示 */
  //       this.storeService.set('hostex_sync_price_tasks', tasks, 2);
  //       const title =
  //         type === Type.PRICE_DAILY
  //           ? '基础价格修改中，请稍等...'
  //           : '周末价格修改中，请稍等...';
  //       this.replaceMessage.emit({
  //         id: type,
  //         data: {
  //           type: type,
  //           status: Status.DOING,
  //           payload: {
  //             title: title
  //           }
  //         },
  //         option: { position: 'center' }
  //       });
  //     });
  // }

  /** 重试手工拉取订单 */
  retrySyncStatusManual() {
    this.statusService.syncManual({});
  }
}
